import React, { Component } from 'react';
import { Affix, Col, Row } from 'antd';

export default class TopoPagina extends Component {
  static propTypes = {

  };

  render() {
    const { titulo } = this.props;
    return (
      <div className="topo-pagina">
        <Affix>
          <div className="componentes-topo-pagina">
            <Row end="xs" justify="space-between" type="flex">
              <Col>
                 <h2>{titulo}</h2>
              </Col>
              <Col className="areaFunctions">
                {this.props.children}
              </Col>
            </Row>
          </div>
        </Affix>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/componentes/TopoPagina.js